<span>
  {{ 'Conversation::AutomaticSummarization:NotificationMessage:0' | abpLocalization }}
  <a href="javascript:void(0)" (click)="onClickNotificationRow($event)">
    {{ 'Conversation::AutomaticSummarization:NotificationMessage:1' | abpLocalization }}
  </a>
  {{ 'Conversation::AutomaticSummarization:NotificationMessage:2' | abpLocalization }}
</span>
